import { ITemplatesListFilters } from '~/services/api/templates/types';

const getInitialFilters = (): ITemplatesListFilters => ({
  name: '',
  typeId: '',
  createdByUserId: '',
});

export default getInitialFilters;
